import { connect } from 'react-redux';

import SessionLoaderPage from './SessionLoaderPage';
import { actionCreators, selectors } from '../../dux/user';

const mapStateToProps = (state) => ({
  originatingURL: selectors.getSessionState(state).originatingURL,
});

const mapDispatchToProps = {
  setSessionHandler: actionCreators.setSession,
};

export default connect(mapStateToProps, mapDispatchToProps)(SessionLoaderPage);
